import { CountUp } from "countup.js";

export default function createCounter(container, initialValue) {
  return new CountUp(container, initialValue);
}
